export default __webpack_public_path__ + "6046df7.png";